import styled from 'styled-components';

import { CONTAINER_PADDING, NARROW_CONTAINER_WIDTH } from '@components/blocks/blocks.constants';
import { colonSuffix, paragraphTextStyles } from '@components/blocks/blocks.styles';
import { media } from '@theme/media';
import { COLORS } from '@theme/colors';
import { OFFSET } from '@theme/helpers';
import { FONT_SIZE } from '@theme/font';

export const Container = styled.div`
  padding-top: ${OFFSET.XL};
  padding-bottom: ${OFFSET.XL};

  ${media.tablet} {
    padding-top: calc(${OFFSET.XL} + ${OFFSET.M});
  }

  ${media.desktop} {
    padding-top: ${OFFSET.XL};
  }

  ${paragraphTextStyles};

  a {
    border-bottom: none;
  }
`;

export const GalleryGrid = styled.div`
  margin: 0 ${CONTAINER_PADDING}px;

  ${media.tablet} {
    margin: 0 auto;
    width: calc(${NARROW_CONTAINER_WIDTH}px + ${OFFSET.XL});
  }

  ${media.desktop} {
    margin: 0;
    width: auto;
    display: grid;
    grid-template-columns:
      calc((100% - ${NARROW_CONTAINER_WIDTH}px - ${OFFSET.XL}) / 2)
      calc(${NARROW_CONTAINER_WIDTH}px + ${OFFSET.XL})
      auto;
  }
`;

export const GalleryColumn = styled.div`
  ${media.desktop} {
    margin-top: ${OFFSET.M};
  }
`;

export const Title = styled.h3`
  ${paragraphTextStyles};
  ${colonSuffix};
  font-weight: 500;
  margin-top: ${OFFSET.S};
  margin-bottom: ${OFFSET.S};
  position: relative;
  hyphens: auto;

  ${media.tablet} {
    margin-bottom: ${OFFSET.XS};
  }

  ${media.desktop} {
    margin: 0;
    padding-left: ${OFFSET.M};
    padding-right: ${OFFSET.M};
  }
`;

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
  overflow-x: auto;
  width: 100vw;
  margin-left: -${OFFSET.M};
  margin-right: -${OFFSET.M};

  ${media.tablet} {
    margin: 0;
    width: calc(${NARROW_CONTAINER_WIDTH}px / 2 + 50vw + ${OFFSET.M});
  }
`;

export const AddressContainerInner = styled.div`
  display: flex;
  min-width: 100%;
  margin-left: ${OFFSET.M};
  margin-right: ${OFFSET.M};

  ${media.tablet} {
    margin: 0;
  }
`;

export const AddressItem = styled.div`
  flex-shrink: 0;
  margin-right: ${OFFSET.M};
  padding: ${OFFSET.M};
  border: 1px solid ${COLORS.BLACK};
  box-sizing: border-box;
  margin-bottom: ${OFFSET.XS};
  width: calc(100vw - ${OFFSET.XL});
  max-width: 306px;

  ${media.tablet} {
    width: 306px;
    margin-right: ${OFFSET.M};
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

export const Logo = styled(AddressItem)`
  & > img {
    height: 100%;
    object-fit: contain;
  }
`;

export const AddressTitle = styled.div`
  text-transform: uppercase;
`;

export const AddressLink = styled.a`
  &:after {
    content: '\\2197';
    margin-left: ${OFFSET.XS};
    transition: transform 0.6s ease-in-out;
  }
`;

export const AddressLinkLine = styled.div`
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
`;

export const AddressLinkLineCountry = styled(AddressLinkLine)`
  display: inline-block;
  max-width: calc(100% - 31px);
`;

export const ArtworksContainer = styled.div`
  margin: ${OFFSET.L} auto;

  ${media.tablet} {
    margin: ${OFFSET.L} ${OFFSET.S} ${OFFSET.XL};
  }
`;

export const ImpressionsImageContainer = styled.div`
  margin: ${OFFSET.L} 0 ${OFFSET.M};

  ${media.desktop} {
    &:first-of-type {
      margin-top: 0;
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const OnPlatformContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${media.tablet} {
    flex-direction: row;
  }
`;

export const PlatformArtistContainer = styled.div`
  &:first-of-type {
    margin-bottom: ${OFFSET.S};
  }

  ${media.tablet} {
    margin-top: ${OFFSET.M};
    width: calc(50% - ${OFFSET.M} / 2);

    &:first-of-type {
      margin-right: ${CONTAINER_PADDING * 1.7}px;
    }
  }

  ${media.desktop} {
    margin-top: 0;

    &:first-of-type {
      margin-right: ${OFFSET.M};
    }
  }
`;

export const PlatformArtistTitle = styled.div``;

export const PlatformArtistLink = styled.a`
  display: block;
  &:before {
    content: '\\2192';
    font-size: ${FONT_SIZE.XS};
    margin-right: 4px;
  }
`;
